import { useEffect } from 'react';
import { InputSearch, useFormContext } from '@ferreri/prever-component-lib';

type LocationSearchInputProps = {
  setIsSearching: (isSearching: boolean) => void;
  setAddress: (address: string) => void;
  isSearching: boolean;
};

export const LocationSearchInput = (props: LocationSearchInputProps) => {
  const { watch } = useFormContext();
  const address = watch('address');

  useEffect(() => {
    if (!address && props.isSearching) {
      props.setIsSearching(false);
    } else if (address && !props.isSearching) {
      props.setIsSearching(true);
    }
  }, [address]);

  const onChange = (value: string) => {
    props.setAddress(value);
  };

  const onFocus = () => {
    props.setIsSearching(true);
  };

  const onBlur = () => {
    if (!address) {
      props.setIsSearching(false);
    }
  };

  return (
    <InputSearch
      name="address"
      placeholder="Buscar endereço"
      onBlur={onBlur}
      onFocus={onFocus}
      onChange={onChange}
    />
  );
};
